export enum DateFormat {
  general = 'dd-MM-yyyy',
  generalReverse = 'yyyy-MM-dd',
  generalWithTime = 'dd-MM-yyyy HH:mm',
}
